import { DefaultReportHeader } from '../components';

const getDisplayedRowData =
  ({ headerProps = null, kpiData = null, ReportHeader = null } = {}) =>
  (gridApi) => {
    const rowData = [];
    gridApi.forEachNodeAfterFilterAndSort((node) => {
      rowData.push(node.data);
    });
    const columns = gridApi.getAllDisplayedColumns().map((col) => col.colDef);
    const finalHeaderProps = headerProps || { title: gridApi.gridName ?? 'RouteMax Report' };
    const FinalReportHeader = ReportHeader || DefaultReportHeader;
    
    return {
      ReportHeader: <FinalReportHeader {...finalHeaderProps} />,
      rowData,
      columns,
      kpiData: kpiData ?? [`Total: ${rowData.length ?? 0} records`]
    };
  };

export { getDisplayedRowData };
